const NAIVE_DATE_TIME = /^\d{4}-\d{2}-\d{2}[T ]\d{2}:\d{2}(:\d{2}(\.\d+)?)?$/;

// Draft dates (campaign start/end, execution dates) start out as API strings from denormalizeCampaign
// and become real Dates once a step applies its edit - both need to parse cleanly so re-opening a step
// (Back) or feeding execution-item-step doesn't silently see null. A naive string is UTC, as the backend
// reads it (new Date() would read it as local time, and Next would then shift the saved value by the
// UTC offset); one with its own offset (Z, +02:00) keeps it. The execution form only works on Dates:
// its custom-value bookkeeping formats them, so a string there throws on open.
export function parseDate(value: unknown): Date | null {
  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value;
  }

  if (!value || typeof value !== 'string') {
    return null;
  }

  const parsed = new Date(NAIVE_DATE_TIME.test(value) ? `${value.replace(' ', 'T')}Z` : value);

  return Number.isNaN(parsed.getTime()) ? null : parsed;
}
